import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {FileDetails} from "../../../../store/state/order.state";

@Component({
    selector: 'transfer-documents-group-info',
    templateUrl: './transfer-documents-group-info.template.html',
    styleUrls: ['./style.scss'],
    standalone: false
})
export class TransferDocumentsGroupInfoComponent implements OnInit {

	@Input() blockInputs: boolean = false;
	@Input() groupTitle: string;
	@Input() fileDetails: FileDetails[];
	@Input() changed: boolean = false;

	@Output() onFileDownload = new EventEmitter<FileDetails>();

	ngOnInit(): void {
	}

	downloadDocument(file: FileDetails) {
		this.onFileDownload.emit(file);
	}
}
